export function formattedMoneyWholeNumber(val, culture) {
  if (parseFloat(val) < 0) {
     return "(" + val.toLocaleString(culture, { style: "currency", maximumFractionDigits: 0, currency: "USD" }).replaceAll("US", "").replaceAll("-", "") + ")";
   }
   else {
     return val.toLocaleString(culture, { style: "currency", maximumFractionDigits: 0, currency: "USD" }).replace(/US/g, "");
   }
}